import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"plus\"><path d=\"M10.504 5.004c.26 0 .496.213.496.496a.499.499 0 0 1-.496.496H5.996v4.485c0 .283-.213.519-.496.519a.504.504 0 0 1-.496-.52V5.997H.496A.499.499 0 0 1 0 5.5c0-.283.236-.496.496-.496h4.508V.52C5.004.236 5.217 0 5.5 0c.283 0 .496.236.496.52v4.484h4.508z\" fill=\"#626469\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol